import { render, staticRenderFns } from "./VerifyCodePage.vue?vue&type=template&id=847011f0&scoped=true"
import script from "./VerifyCodePage.vue?vue&type=script&lang=js"
export * from "./VerifyCodePage.vue?vue&type=script&lang=js"
import style0 from "./VerifyCodePage.vue?vue&type=style&index=0&id=847011f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847011f0",
  null
  
)

export default component.exports